module.exports = __webpack_public_path__ + "img/symbol_7.cb0b7b1c.png";